import theme from '@/theme';
import styled from 'styled-components';

export const StudioWrapper = styled.div`
    background-color: ${theme.color.white};
    display: flex;
    flex: 1;
    flex-direction: row;
    overflow: hidden;
    height: 100%;
    width: 100%;
    position: relative;
`;
